<script lang="ts" setup>
import { CriteriaInstance } from "types/Checklist";
import {
  EvaluationCriteria,
  EvaluationRelevantInstance,
} from "~/types/EvaluationResults";

const { criteriaInstance, paragraphPosition } = defineProps({
  criteriaInstance: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  criteriaList: {
    type: Array as PropType<EvaluationCriteria[]>,
  },
  checklistCriteria: {
    type: Object as PropType<ChecklistCriteria>,
    required: true,
  },
  isTopLevel: {
    type: Boolean,
    required: false,
    default: false,
  },
  paragraphPosition: {
    type: Number,
    required: false,
  },
  relevantInstance: {
    type: Object as PropType<EvaluationRelevantInstance>,
    required: false,
  },
});

const emits = defineEmits(["reportProblem"]);

const onReportProblem = (criteria: EvaluationCriteria, isControl: boolean) => {
  emits("reportProblem", criteria, isControl);
};
</script>

<template>
  <div
    v-if="
      criteriaList && criteriaInstance && criteriaInstance?.checklistCriteriaId
    "
  >
    <EvaluationResultsCriteriaListItem
      v-for="(criteria, index) in criteriaList"
      :key="`${criteria.id}-${index}-${criteria.passed}-${criteria.isOverriden}`"
      :criteria-instance="criteriaInstance"
      :criteria="criteria"
      :checklist-criteria="checklistCriteria"
      :paragraph-position="paragraphPosition"
      :relevant-instance="relevantInstance"
      :is-top-level="isTopLevel"
      @reportProblem="onReportProblem"
    />
  </div>
</template>

<style scoped></style>
